import { createActions } from 'lessdux'

export const JMProjections = createActions('JM_PROJECTIONS')

export const changeJMProjections = ({ useJM }) => {
  return {
    type: JMProjections.FETCH,
    useJM
  }
}